export default __webpack_public_path__ + "static/media/screen3.b7c740e1.png";